export default {
  teamDeployments: [],
};
